import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { dashboardLayoutComponent } from '@/routes/layouts/dashboard-layout-route';
import type { FilterDrawerFormValue } from '@/components/shared/filter-drawer/types';

export const paymentLinkRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/payment-link',
  component: lazyRouteComponent(() => import('@/pages/payment-link/payment-link-page')),
  validateSearch: (search: Record<string, unknown>): FilterDrawerFormValue => {
    return {
      ...search,
    };
  },
});

export const createPaymentLinkRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/payment-link/create',
  component: lazyRouteComponent(() => import('@/pages/payment-link/create-payment-link-page')),
});

export const paymentLinkDetailRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/payment-link/$id',
  component: lazyRouteComponent(() => import('@/pages/payment-link/payment-link-detail-page')),
});
